
import BaseAction from "../base_action";
import { UPDATE_RISK_TAGS, UPDATE_ACCOUNTABLE_MANAGER } from '../../constants'

export default class RiskAction extends BaseAction {
  baseUrl = "/__api/v1/risks/"

  updateRiskTags = (risk) => {
    const actionTypes  = UPDATE_RISK_TAGS;
    const url = this.composeUrl(risk.id, "/tags");
    return this.apiPut(actionTypes, url, risk);
  }

  updateAccountableManager = (risk) => {
    const actionTypes = UPDATE_ACCOUNTABLE_MANAGER;
    const url = this.composeUrl(risk.id, "/accountable_manager");
    return this.apiPut(actionTypes, url, risk);
  }
}


// WEBPACK FOOTER //
// ./src/actions/v2/risk.js